export default "__VITE_ASSET__BA2I3kjR__"